'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var myReservationsComponent = exports.myReservationsComponent = {
    template: require('./my-reservations.html'),
    controllerAs: 'vm',
    controller: ["common", "gettextCatalog", function myReservationsController(common, gettextCatalog) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.myFebelcoLink = 'https://www.myfebelco.be/MyPharmacy/Reservations';

        function init() {
            common.setTitle(gettextCatalog.getString('Overzicht producten in reservatie'));
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/account/my-reservations.js
// module id = 867
// module chunks = 0